export const COOKIE_TYPES = {
  FUNCTIONAL: 'functional',
  ANALYTICS: 'analytics',
  ADVERTISING: 'advertising'
} as const;

export type CookieType = typeof COOKIE_TYPES[keyof typeof COOKIE_TYPES];

// Responses

export interface ICookieResponse {
  id: number,
  slug: string,
  label: string,
  name: string,
  type: CookieType
}

export interface ICookieDefinitionsResponse {
  cookies: ICookieResponse[]
}

// Requests

export interface IUpdateConsentPayload {
  timestamp: number,
  hasGivenFullConsent: boolean,
  cookies: Pick<ICookie, 'slug' | 'isAccepted'>[]
}

// Models

export interface ICookie {
  id?: number,
  slug: string,
  label?: string,
  name?: string,
  type?: CookieType,
  isAccepted: boolean,
  hasSetConsent?: boolean
}

export interface IConsent {
  timestamp?: number,
  cookies: ICookie[],
  hasGivenConsent?: boolean,
  hasGivenFullConsent: boolean,
  shouldRequestConsent?: boolean
}
